module.exports = __webpack_public_path__ + "img/about_logo_16.a46960ef.png";